import { createReducer } from '@reduxjs/toolkit'

import { locale as esLocale } from 'shared/locale/es-ES'

import * as actions from '../actions'
import { ILocaleState } from '../types'

const initialState: ILocaleState = {
  data: esLocale,
}

export default createReducer(initialState, builder => {
  builder.addCase(actions.changeLang, (state, action) => {
    state.data = action.payload
  })
})
